import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import type { Product } from "@/models/product.model"

export const useProductsStore = defineStore("products", () => {
  const products: Ref<Product[]> = ref([])
  const appProducts: Ref<Product[]> = ref([])

  return {
    products,
    appProducts
  }
})
